<app-pasfoto [pasfoto]="data.pasfoto" size="size-2"></app-pasfoto>
<div class="details">
	<span class="naam">{{ data.leerlingNaam }}</span>
	<span class="leerlingnummer">{{ data.leerlingNummer }}</span>
</div>
